// extracted by mini-css-extract-plugin
export default {"wrapper":"Certificates_wrapper__5Rtal","body_wrapper":"Certificates_body_wrapper__csEOB","certificatesGrid":"Certificates_certificatesGrid__gwa10"};